

import fragment from './bulge.frag.glsl';

function BulgeFilter()
{
    PIXI.AbstractFilter.call(this);

    this.uniforms = {
        radius:     { type: '1f', value: 0.5 },
        strength:   { type: '1f', value: 0.25 },
        center:     { type: 'v2', value: { x: 0.5, y: 0.5 } }
    }
    
    this.fragmentSrc = fragment;
}

BulgeFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
BulgeFilter.prototype.constructor = BulgeFilter;

Object.defineProperties(BulgeFilter.prototype, {
    

    center: {
        get: function ()
        {
            return this.uniforms.center.value;
        },
        set: function (value)
        {
            this.uniforms.center.value = value;
        }
    },

    radius: {
        get: function ()
        {
            return this.uniforms.radius.value;
        },
        set: function (value)
        {
            this.uniforms.radius.value = value;
        }
    },

    strength: {
        get: function ()
        {
            return this.uniforms.strength.value;
        },
        set: function (value)
        {
            this.uniforms.strength.value = value;
        }
    }
});




module.exports = BulgeFilter;



/** WEBPACK FOOTER **
 ** ./src/js/controllers/filters/bulgeFilter.js
 **/